import { Link } from 'react-router-dom';
import SEOHead from '../../components/SEOHead';

interface Product {
  id: number;
  name: string;
  description: string;
  price: string;
  image: string;
  amazonLink: string;
}

const products: Product[] = [
  {
    id: 1,
    name: "COSRX Snail Mucin 96 Power Essence",
    description: "The K-Beauty phenomenon that hydrates and repairs skin barrier. It is currently one of the highest-volume beauty items on Amazon.",
    price: "$16.20",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/9044523ac814cee5aae38b7cfd8d98f4.png",
    amazonLink: "https://amzn.to/49AGm6y"
  },
  {
    id: 2,
    name: "Mighty Patch Original from Hero Cosmetics",
    description: "Hydrocolloid stickers that flatten pimples overnight. They are the top-selling acne treatment due to their speed and invisibility.",
    price: "$12.99",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/cc03291abd3c36703305c7a7458e613a.png",
    amazonLink: "https://amzn.to/4aXEuXV"
  },
  {
    id: 3,
    name: "Mielle Organics Rosemary Mint Scalp Oil",
    description: "A strengthening hair oil that went viral for promoting hair growth and retention, especially for textured hair.",
    price: "$9.97",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/b8f68a5fda660011d92cce30ba2b4b77.png",
    amazonLink: "https://amzn.to/3LAUzsf"
  },
  {
    id: 4,
    name: "GrandeLASH-MD Lash Enhancing Serum",
    description: "The best-selling lash serum that promotes the appearance of longer, thicker lashes in 4-6 weeks.",
    price: "$65.00",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/46281f878954dd6a97bbe9d2fb1bdb31.png",
    amazonLink: "https://amzn.to/4qkSVdb"
  },
  {
    id: 5,
    name: "PanOxyl Acne Foaming Wash",
    description: "A dermatologist-recommended benzoyl peroxide wash that is widely used for treating face, chest, and back acne.",
    price: "$9.88",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/145b37ee23ce5f3e70ebf947a2883159.png",
    amazonLink: "https://amzn.to/3YICZ8D"
  },
  {
    id: 6,
    name: "Paula's Choice Skin Perfecting 2% BHA",
    description: "A leave-on exfoliant that unclogs pores and smooths wrinkles. It is famously known as a \"facial in a bottle.\"",
    price: "$32.00",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/da3c4bec11a2a0e016e932a4084f0144.png",
    amazonLink: "https://amzn.to/4sCDTBr"
  },
  {
    id: 7,
    name: "Laneige Lip Sleeping Mask",
    description: "A rich overnight lip treatment that gained massive popularity for curing dry, chapped lips while you sleep.",
    price: "$24.00",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/540aacbe77f494e3fc9c7dd3db63c73a.png",
    amazonLink: "https://amzn.to/4jG1CMX"
  },
  {
    id: 8,
    name: "Essence Lash Princess False Lash Effect Mascara",
    description: "Famous for outperforming luxury mascaras at a fraction of the price (usually under $5), giving dramatic volume and length.",
    price: "$14.97",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/6e5de9c25af3d3010f82a4d19901b2bb.png",
    amazonLink: "https://amzn.to/4b1cdj8"
  },
  {
    id: 9,
    name: "Bioderma Sensibio H2O Micellar Water",
    description: "A gentle makeup remover that cleanses without stripping skin, beloved by makeup artists and models worldwide.",
    price: "$14.90",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/9d7915f45ea932338ee1bebf3010f603.png",
    amazonLink: "https://amzn.to/4jGGyWx"
  },
  {
    id: 10,
    name: "Tree Hut Shea Sugar Scrub",
    description: "The internet's favorite body scrub for smooth, glowing skin, available in popular scents like Moroccan Rose and Vitamin C.",
    price: "$9.99",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/696222473cd72dd73a6163d69d5ac974.png",
    amazonLink: "https://amzn.to/4b1rf8K"
  }
];

export default function BeautyEssentialsPage() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Beauty Essentials - Affordable Beauty Products",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/beauty-essentials`,
    "description": "Affordable holy grails and pharmacy favorites dominating the charts. Top-rated beauty products including COSRX Snail Mucin, Mighty Patch, and more.",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": products.map((product, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "@type": "Product",
          "name": product.name,
          "description": product.description,
          "offers": {
            "@type": "Offer",
            "price": product.price.replace('$', ''),
            "priceCurrency": "USD",
            "availability": "https://schema.org/InStock",
            "url": product.amazonLink
          }
        }
      }))
    }
  };

  return (
    <>
      <SEOHead
        title="Beauty Essentials - Affordable Skincare & Makeup Products"
        description="Discover top-rated beauty essentials including COSRX Snail Mucin, Mighty Patch, Mielle Rosemary Mint Oil, GrandeLASH Serum, and more. Affordable holy grails and pharmacy favorites."
        keywords="beauty essentials, skincare products, makeup products, k-beauty, affordable beauty, cosrx, mighty patch, beauty recommendations"
        canonicalPath="/beauty-essentials"
        schemaData={schemaData}
      />
      <div className="min-h-screen w-full animated-gradient px-4 py-12">
        <div className="w-full max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <Link 
              to="/" 
              className="inline-flex items-center gap-2 text-white/90 hover:text-white mb-6 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-2xl"></i>
              <span className="text-lg">Back to Home</span>
            </Link>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4">
              💄 Beauty Essentials
            </h1>
            <p className="text-white/90 text-lg md:text-xl">
              Affordable holy grails and pharmacy favorites dominating the charts
            </p>
          </div>

          {/* Products Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {products.map((product) => (
              <div 
                key={product.id}
                className="bg-white/95 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 flex flex-col"
              >
                <div className="w-full h-64 overflow-hidden">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6 flex flex-col flex-grow">
                  <h3 className="text-xl font-bold text-gray-800 mb-3">{product.name}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4 flex-grow">{product.description}</p>
                  <div className="flex items-center justify-end mt-auto">
                    <a
                      href={product.amazonLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-gradient-to-r from-[#7b6ba8] to-[#8b7bb8] hover:from-[#6b5b98] hover:to-[#7b6ba8] text-white font-semibold py-3 px-6 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
                    >
                      <span>View on Amazon</span>
                      <i className="ri-amazon-fill text-xl"></i>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Footer */}
          <div className="text-center space-y-4">
            <p className="text-white/90 text-sm md:text-base">
              As an Amazon Associate, I earn from qualifying purchases support the hustle 💋
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
